import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.loyaltyApiBaseUrl;

export default {
  async fetchClients(query = "") {
    const queryString = query ? `${query}&join=apps&join=tier` : "";
    const url = `${URL}v1/apps/clients${queryString}`;
    return (await httpClient.get(url)).data;
  },
  async fetchClientCoupon(query, id) {
    const queryString = `/${id}/coupons${query}&join=coupon&join=client&join=coupon.app`;
    const url = `${URL}v1/apps/clients${queryString}`;
    return (await httpClient.get(url)).data;
  },
  async assignCoupons(payload) {
    const url = `${URL}v1/apps/clients/coupons`;
    return await httpClient.post(url, payload);
  },
  async importClients(file) {
    const url = `${URL}v1/apps/clients/reports`;
    let excelFile = new FormData();
    excelFile.append("file", file);
    return await httpClient.post(url, excelFile);
  },
  async importPoints(file) {
    const url = `${URL}v1/apps/clients/import-points`;
    let excelFile = new FormData();
    excelFile.append("file", file);
    return await httpClient.post(url, excelFile);
  },
  async syncYaseerPoints(file, appId) {
    const url = `${URL}v1/apps/clients/sync-yaseer-points?appId=${appId}`;
    let excelFile = new FormData();
    excelFile.append("file", file);
    return await httpClient.post(url, excelFile);
  },
  async exportClients() {
    const url = `${URL}v1/apps/clients/reports`;
    const response = await httpClient.get(url, { responseType: "arraybuffer" });
    let fileURL = window.URL.createObjectURL(new Blob([response.data]));
    let fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", "clients.csv");
    document.body.appendChild(fileLink);
    fileLink.click();
  },
};
